<template>
    <div class="error-page">
        <h1><slot name="code"></slot></h1>
        <section class="info">
            <h2><slot name="header"></slot></h2>
            <p>
                <slot name="description"></slot>
            </p>
        </section>
        <section class="logo">
            <a href="http://logito.pl" class="logo">
                <img src="data:image/png;base64,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" />
            </a>
        </section>
        <section class="back">
            <a href="/">
                <i class="arrow"></i>
                <span>{{ $t('[[[Wróć do strony głównej]]]') }}</span>
            </a>
        </section>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class ErrorLayout extends Vue
{
}
</script>

<style lang="scss" scoped>
.error-page {
    --ico-arrow: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9Ijc2OCIgaGVpZ2h0PSI3NjgiIHZpZXdCb3g9IjAgMCA3NjggNzY4Ij48dGl0bGU+PC90aXRsZT48ZyBpZD0iaWNvbW9vbi1pZ25vcmUiPjwvZz48cGF0aCBmaWxsPSIjMDAwIiBkPSJNNTc2IDM1MmgtMjMxLjgwOGw1MC43NTItNTAuNzUyYzI0Ljk5Mi0yNC45OTIgMjQuOTkyLTY1LjU2OCAwLTkwLjQ5Ni0yNC45OTItMjQuOTkyLTY1LjUwNC0yNC45OTItOTAuNDk2IDBsLTIwNS4yNDggMjA1LjI0OCAyMDUuMjQ4IDIwNS4yNDhjMTIuNDggMTIuNTEyIDI4Ljg2NCAxOC43NTIgNDUuMjQ4IDE4Ljc1MnMzMi43MzYtNi4yNCA0NS4yNDgtMTguNzUyYzI0Ljk5Mi0yNC45OTIgMjQuOTkyLTY1LjU2OCAwLTkwLjQ5NmwtNTAuNzUyLTUwLjc1MmgyMzEuODA4YzM1LjMyOCAwIDY0LTI4LjY3MiA2NC02NCAwLTM1LjM2LTI4LjY3Mi02NC02NC02NHoiPjwvcGF0aD48L3N2Zz4=);
    --error-bg: linear-gradient(to right, #0e1824 50%, #fff 50%);
    --error-color: #0e1824;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    background: var(--error-bg);

    a {
        text-decoration: none;
    }
    h1 {
        font-size: 160px;
        font-weight: normal;
        letter-spacing: 30px;
        margin-right: -30px;
        color: #fff;
        mix-blend-mode: difference;
    }
    .info {
        position: absolute;
        bottom: 15%;
        left: 10%;
        right: 60%;
        color: #fff;
        mix-blend-mode: difference;

        h2 {
            margin-bottom: 18px;
            font-size: 45px;
            font-weight: 700;
            text-align: center;
        }
        p {
            text-align: center;
            font-size: 20px;
        }
    }
    .logo {
        position: absolute;
        bottom: 15%;
        right: 10%;
    }
    .back {
        position: absolute;
        top: 10%;
        right: 10%;

        a {
            font-size: 17px;
            font-weight: 700;
            color: var(--error-text-color);

            i.arrow {
                display: inline-block;
                width: 19px;
                height: 20px;
                margin-right: 7px;
                background-image: var(--ico-arrow);
                background-size: cover;
                transition-duration: 0.3s;
                font-size: 22px;
                vertical-align: -3px;
            }

            &:hover {
                text-decoration: none;

                i.arrow {
                    margin-right: 14px;
                }
            }
        }
    }
}

@media screen and (max-width: 1400px) {
    .error-page {
        .info {
            h2 {
                margin-bottom: 12px;
                font-size: 36px;
            }
            p {
                font-size: 16px;
            }
        }
    }
}

@media screen and (max-width: 1120px) {
    .error-page {
        .info {
            h2 {
                margin-bottom: 8px;
                font-size: 24px;
            }
            p {
                font-size: 13px;
            }
        }
        .back span {
            display: none;
        }
    }
}

@media screen and (max-width: 640px) {
    .error-page {
        h1 {
            font-size: 100px;
        }
        .info {
            left: 10%;
            right: 10%;
        }
        .logo {
            display: none;
        }
    }
}

@media screen and (max-height: 640px) {
    .error-page {
        .info {
            bottom: 10%;
        }
    }
}
</style>
